
import * as React from "react";
import $ from "jquery";
import { IUserRestaurantListItem } from "../../interfaces/IRestaurant";
import { Api } from "../../lib/Api";
import RestaurantMap from "./RestaurantMap";
import { IOfferListItem } from "../../interfaces/IOffer";
import { Order, IOfferWithPiece } from "./Order";
import { ISetUrl } from "../../AppMain";
import { Lng } from "../../../languages/Languages";
import Config from "../../Config";
import ProfessionalItem from "./ProfessionalItem";
import SelectProfessional from "./SelectProfessional";
import ConfirmOrder from "./ConfirmOrder";
import LoaderComp from "../../../avernus/loader/source/LoaderComp";

export type IViewForViewRestaurant = 'showRestaurant' | 'submitOrder';

interface IViewRestaurantProps {
    setUrl              : ISetUrl
    restaurantId        : number
    view                : IViewForViewRestaurant
}


export interface IViewData extends IUserRestaurantListItem{
    description:string
}

interface IViewRestaurantState {
    loading              : boolean
    item                 : IViewData
    descriptionSmallView : boolean
    offers               : Array<IOfferListItem>
    view                 : IViewForViewRestaurant
    whatIsABoxModalOpened: boolean
    showDescription      : boolean
    selectedProfessional: any
    confirmOrder        : boolean
    startDateTime:  any
    endDateTime: any
    hours               : any
    description         : any
    photo               : any
}

interface IResult{
    item  : IViewData
    offers: Array<IOfferListItem>
}

export default class ViewRestaurant extends React.Component<IViewRestaurantProps, IViewRestaurantState>{

    constructor(props:IViewRestaurantProps){
        super(props);
        this.state = {
            loading              : true,
            item                 : null,
            descriptionSmallView : true,
            offers               : [],
            view                 : this.props.view,
            whatIsABoxModalOpened: true,
            showDescription      : false,
            selectedProfessional : [],
            confirmOrder         : false,
            startDateTime        : '',
            endDateTime          : '',
            hours                : '',
            description          : '',
            photo                : ''
        };
        this.get();
    }

    private get():void{
        if ( this.state.view === 'submitOrder' ) {
            setTimeout(() => {
                this.setState({
                    item:       Order.getRestaurant(),
                    offers:     Order.getOffers(),
                    loading:    false
                });


            }, 100);
        }else{
            Api.getGeoLocation((position)=>{
                if ( position !== null ) {
                    Api.call('/user/restaurant/getOffer', {
                        restaurantId:   this.props.restaurantId,
                        longitude:      position.coords.longitude,
                        latitude:       position.coords.latitude
                    }, (result)=>{
                        console.log(result);
                        this.setState({
                            item:   result.item,
                            offers: result.item.offer,
                            loading: false
                        });
                    });
                }else{
                    Api.call('/user/restaurant/getOffer', {
                        restaurantId:   this.props.restaurantId,
                        longitude:      0,
                        latitude:       0
                    }, (result)=>{
                        console.log(result);
                        this.setState({
                            item:   result.item,
                            offers: result.item.offer,
                            loading: false
                        });
                    });
                    alert(Lng.get('user_restlist_enalbegeo'));
                }
            });
        }
    }

    private toggleLikeClickHandler(evt, restaurantId:number): void {
        evt.preventDefault();
        if (Api.isFrontUser()) {
            Api.call('/user/restaurant/toggleLike', {
                restaurantId: restaurantId
            }, (result) =>{
                if ( result.success === true ) {
                    let item = this.state.item;
                    item.liked = !item.liked;
                    this.setState({
                        item: item
                    });
                }
            });
        }
    }

    private changeOfferPieceHandler(evt): void {
        evt.preventDefault();
        let offers               = this.state.offers;
        (offers[0] as any).piece = parseFloat(evt.target.value);
        Order.setOffer((offers[0] as any));
        this.setState({
            offers: offers
        });

    }

    private modifyOfferPieceClickHandler(evt, modifier:number=-1): void {
        evt.preventDefault();
        let offers      = this.state.offers;
        let piece       = (offers[0] as any).piece + modifier;
        let maxPiece    = parseFloat(offers[0].availablePortions);
        if ( piece <= maxPiece && piece > 0  ) {
            (offers[0] as any).piece = piece;
            Order.setOffer((offers[0] as any));
            this.setState({
                offers: offers
            });
        }

    }


    private submitOrderClckHandler(evt): void {
        evt.preventDefault();
        this.props.setUrl('/user/payment');
    }

    private successOrder() {
        this.props.setUrl('/user/index');
    }


    private submitOrder(item:IViewData){
        let offer:IOfferWithPiece = this.state.offers[0] as any;
        let pieceOptions:Array<number> = [];
        for (let index = 1; index <= parseInt(offer.availablePortions); index++) {
            pieceOptions.push(index);
        }

        if ( this.state.whatIsABoxModalOpened === true ) {
            setTimeout(() => {
                if ( document.querySelector('#what_is_box_modal') !== null ) {
                    $('#what_is_box_modal').modal({show:true});
                }
            }, 200);
        }
        if ( this.state.showDescription === true ) {
            setTimeout(() => {
                if ( document.querySelector('#description_modal') !== null ) {
                    $('#description_modal').modal({show:true});
                }
            }, 200);
        }
        return <>
            <div className="restaurant_row">
                <div>
                    <div className="bottom_row">
                        <div>
                            { item.img !== null?<div>
                                <div className="logo_box">
                                    <img src={item.img} alt=""/>
                                </div>
                            </div>:'' }

                            <div className="title_box">
                                <h3>
                                    {item.name}
                                    <span className="rateing_star_inline_box">
                                        { item.rateing >= 1?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                        { item.rateing >= 2?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                        { item.rateing >= 3?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                        { item.rateing >= 4?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                        { item.rateing >= 5?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                    </span>

                                </h3>
                                <strong>{item.restaurantTypeName}</strong>
                            </div>
                            <a className="like_box" onClick={ (e) => { this.toggleLikeClickHandler(e, item.id); } }>
                                { item.liked === true?<img src="img/facourite_icon.svg" width={35} alt=""/>:<img src="img/favourite_add_icon_green.svg" width={35} alt=""/> }
                            </a>


                        </div>
                    </div>
                    <div className="footer_row row">
                        <div className="col today_box">
                            <strong>{Lng.get('user_restlist_today')}</strong> { item.openingTodayStart }-{item.openingTodayEnd }
                        </div>
                        <div className="col distance_box">
                            <img src="img/map_search_icon.svg" width="10" alt=""/> <strong>{ item.distance.toFixed(0) } km</strong>
                        </div>
                        <div className="col restaurant_types_box text-right">
                            {
                                item.offerTypeIds.map((id, index)=>{
                                    return <span key={'rtype_'+index} >
                                        { id === 1?
                                            <img src="img/box_icon_kicsi.svg" width="23" alt=""/>
                                        :'' }
                                        { id === 2?
                                            <img src="img/tal_icon.svg" width="25" alt=""/>
                                        :'' }
                                        { id === 3?
                                            <img src="img/happy_hour_icon.svg" width="18" alt=""/>
                                        :'' }

                                    </span>
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="good_choice_row">
                <div className="box_shape">
                    <img src="img/box_icon_nagy.svg" alt="" />
                </div>
                <h2>
                {Lng.get('user_viewrest_goodchoice')}
                </h2>
                <h3>
                    { offer.name }
                </h3>
            </div>
            <div className="set_up_piece_row">
                <div>
                    <strong>{Lng.get('user_viewrest_pickuptime')}</strong> {Lng.get('user_viewrest_today')}
                </div>
                <div className="time_row">
                    { offer.startTime }-{ offer.endTime }
                </div>

                <div className="piece_row row">
                    <div id="decrease_btn" className="col text-right">
                        <a onClick={ (e) => { this.modifyOfferPieceClickHandler(e, -1); } }>
                            <i className="icon ion-minus"></i>
                        </a>
                    </div>

                    <div className="col center">

                        <select id="piece_text" key={ 'select_'+offer.piece } defaultValue={ offer.piece.toString() } className="form-control" onChange={ e => this.changeOfferPieceHandler(e) }>
                            { pieceOptions.map((item:number, key:number) => {
                                return <option key={key} value={item}>
                                    { item }
                                </option>
                            })}
                        </select>

                    </div>

                    <div className="col text-left">
                        <a id="increase_btn" onClick={ (e) => { this.modifyOfferPieceClickHandler(e, 1); } }>
                            <i className="icon ion-plus"></i>
                        </a>
                    </div>

                </div>


                <div className="price_row">
                    { offer.discountedPrice  > 0 && offer.discountedPrice < offer.originalPrice ?<>
                        <span className="discounted_price">
                            { offer.originalPrice*offer.piece }{ offer.currency}
                        </span>
                        <span className="original_price">
                        { offer.discountedPrice*offer.piece }{ offer.currency}
                    </span>
                    </>:<span className="original_price">
                        { offer.originalPrice*offer.piece }{ offer.currency}
                    </span> }

                </div>
                <div className="sobras_credit_row">
                    <img src="img/sobras_credit_icon.svg" width="18" alt=""/> { offer.sobrasCredit } {Lng.get('user_viewrest_sc')}
                </div>
            </div>

            <div className="submit_button_row">
                <a className="btn" onClick={ (e) => { this.submitOrderClckHandler(e); } }>
                {Lng.get('user_viewrest_submit')}
                </a>

            </div>

            {  offer.description !== ''?<div className="ingredients_and_allergens">
                <div>
                    <img src="img/figura_3.svg" alt="" width={60} onClick={ (e) => {
                        e.preventDefault();
                        this.setState({
                            showDescription: true
                        });
                    }} />
                    <a onClick={ (e) => {
                        e.preventDefault();
                        this.setState({
                            showDescription: true
                        });
                    }}>
                        <img src="img/information_icon.svg" alt="" width={10} />
                        {Lng.get('user_viewrest_ings')}
                    </a>
                </div>
            </div>:'' }

            { this.state.showDescription === true?<div role="dialog" className="modal fade" id="description_modal">
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="good_choice_row">
                                <div className="box_shape">
                                    <img src="img/box_icon_nagy.svg" alt="" />
                                </div>
                                <h2>
                                {Lng.get('Ingredients and allergens')}
                                </h2>
                                <div className="description">
                                    { offer.description }
                                </div>
                                <button className="btn" id="accept_btn" onClick={ (e) => {
                                    e.preventDefault();
                                    $('#description_modal').modal('toggle');
                                    if ( document.querySelector('.modal-backdrop') !== null ) {
                                        $('.modal-backdrop').remove();
                                    }
                                    this.setState({
                                        showDescription: false
                                    });
                                }}
                                >{Lng.get('Close')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>:'' }

            { this.state.whatIsABoxModalOpened === true?<div role="dialog" className="modal fade" id="what_is_box_modal">
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="good_choice_row">
                                <div className="box_shape">
                                    <img src="img/box_icon_nagy.svg" alt="" />
                                </div>
                                <h2>
                                {Lng.get('user_viewrest_whatisa')} { offer.offerType.name }?
                                </h2>
                                <div className="description">
                                    { offer.box_description !==''?offer.box_description:<>
                                            { Lng.get('user_viewrest_plsnote') } <br /><br /> {Lng.get('user_viewrest_enjoy')}
                                        </>
                                    }
                                </div>
                                <button className="btn" id="accept_btn" onClick={ e => this.acceptModalClickHandler(e) }
                                >{Lng.get('user_viewrest_accept')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>:'' }
        </>
    }

    private acceptModalClickHandler(evt): void {
        evt.preventDefault();
        $('#what_is_box_modal').modal('toggle');
        if ( document.querySelector('.modal-backdrop') !== null ) {
            $('.modal-backdrop').remove();
        }
        this.setState({
            whatIsABoxModalOpened: false
        });
    }

    private selectProfessional(professional){
        this.setState({
            selectedProfessional: professional
        });
    }

    private confirmOrder(data){

        console.log(data);

        this.setState({
            confirmOrder: true,
            endDateTime: data.endDateTime,
            startDateTime: data.startDateTime,
            hours: data.hours,
            description: data.description,
            photo: data.photo
        })
    }

    private showRestaurant(item:IViewData){

        let descriptionSmallViewText = Lng.get('user_viewrest_read') + ' ' + (this.state.descriptionSmallView===true?'more':'less');
        if ( Config.getLang() === 'hu' ) {
            descriptionSmallViewText = this.state.descriptionSmallView===true?Lng.get('user_viewrest_read'):Lng.get('less');
        }
        return <>
            <div className="restaurant_row">
                <div>
                    <div className = "cover_image">
                        <img src = "/img/users/cover_image_viewrestaurant.png"  width = "100%"/>
                    </div>

                    <div className="content_row">
                        <div className = "image">
                            {
                                item.offer[0].creator.photos?.profilePhoto.length > 0 &&
                                <img src={item.offer[0].creator.photos?.profilePhoto} />
                            }
                        </div>
                        <div className = "content">
                            <p className = "name">{item.name}</p>
                            <div className = "info">
                                <p>
                                    100 m - available today:
                                </p>
                                <p>
                                    14:00-16:00
                                </p>
                            </div>
                            {
                                item.rateing > 0 &&
                                <span className="rateing_star_inline_box">
                                    { item.rateing >= 1?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                    { item.rateing >= 2?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                    { item.rateing >= 3?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                    { item.rateing >= 4?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                    { item.rateing >= 5?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                </span>
                            }
                        </div>
                        <a className="like_box" onClick={ (e) => { this.toggleLikeClickHandler(e, item.id); } }>
                            { item.liked === true?<img src="img/unlike_icon.svg" width={24} alt=""/>:<img src="img/like_icon.svg" width={24} alt=""/> }
                        </a>

                    </div>

                    { item.description !== ''?<>
                        <div className={'description_row '}>
                            <p>
                                { item.description }
                            </p>
                        </div>
                    </>:'' }

                </div>
            </div>

            <div className="offer_list_for_user">
                {
                    this.state.selectedProfessional.length != 0 ?
                        <SelectProfessional professional={this.state.selectedProfessional} confirmOrder={(data) => this.confirmOrder(data)}/> : (
                         this.state.offers.map((item, index) => (
                             <ProfessionalItem professional={item} index={index} select = {(item) => this.selectProfessional(item)}/>
                         ))
                    )
                }
            </div>

            <div className = "back-btn">
                <button type="button" className="purple_btn">Back to the list</button>
            </div>

        </>;
    }

    render() {
        let item = this.state.item;
        setTimeout(() => {
            if ( this.props.view === 'submitOrder' ) {
                document.querySelector('.offer_section_view ').classList.add('no_border');
                document.querySelector('body').classList.add('submit_order_page');
                if ( document.querySelector('body.submit_order_page .container.content_section') !== null ) {
                    (document.querySelector('body.submit_order_page .container.content_section') as HTMLDivElement).style.top = -1*( 60 + (document.querySelector('.restaurant_row>div .bottom_row') as HTMLDivElement).offsetHeight)+'px';
                }
            }else{
                document.querySelector('.offer_section_view ').classList.remove('no_border');
                document.querySelector('body').classList.remove('submit_order_page');
                if ( document.querySelector('body.submit_order_page .container.content_section') !== null ) {
                    (document.querySelector('body.submit_order_page .container.content_section') as HTMLDivElement).style.top = 0+'px';
                }
            }
        }, 100);
        return (
           <>
               {
                   this.state.confirmOrder ?
                       <ConfirmOrder
                           professional={this.state.selectedProfessional}
                           user = {this.state.item}
                           startDateTime = {this.state.startDateTime}
                           endDateTime = {this.state.endDateTime}
                           hours = {this.state.hours}
                           description = {this.state.description}
                           photo = {this.state.photo}
                           successResponse = {() => this.successOrder()}
                       /> :
                       <div className={ 'restaurant_view_section ' + (this.props.view === 'showRestaurant'?'show_restaurant':'') + (this.props.view === 'submitOrder'?'submit_order':'') }>
                           { this.state.loading === true?<div style={{
                               textAlign: 'center',
                               paddingTop: '40px'
                           }}>
                               <LoaderComp show={true} />
                           </div>:<>
                               { item !== null && this.props.view === 'showRestaurant' ?this.showRestaurant(item):'' }
                               { item !== null && this.props.view === 'submitOrder' ?this.submitOrder(item):'' }

                           </> }
                       </div>
               }
           </>
        );
    }
    orderBtnClickHandler(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, item: IOfferListItem) {
        e.preventDefault();
        console.log('orderBtnClickHandler');
        Order.setRestaurant(this.state.item);
        let offerItem   : IOfferWithPiece = item as any;
        offerItem.piece = 1;
        Order.setOffer(offerItem);

        this.props.setUrl('/user/submit-order');

    }
    toogleDescripitonSmallView(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        e.preventDefault();
        this.setState({
            descriptionSmallView: !this.state.descriptionSmallView
        });
    }
}
